<template>
    <div class="certificate-example">
      <div class="example-img">
        <img :src="imageSrc" :alt="imageAlt" />
      </div>
      <div class="example-text">
        <h2 v-if="!customDescription">{{ title }}</h2>
        <p v-html="description"></p>
        <a :href="downloadLink" target="_blank">
          <button class="see-example" v-if="customLabel">
            {{ customLabel }}
          </button>
          <button class="see-example" v-else>
            Guarda esempio
          </button>
        </a>
      </div>
    </div>
  </template>

  <script>
  export default {
    name: 'CertificateExample',
    props: {
      type: {
        type: String,
        required: true,
      },
      vehicle_type: {
        type: String,
        required: true,
      },
      customImageUrl: {
        type: String,
        default: ''
      },
      customImageName: {
        type: String,
        default: ''
      },
      customDescription: {
        type: String,
        default: ''
      },
      customLink: {
        type: String,
        default: ''
      },
      customLabel: {
        type: String,
        default: ''
      },
    },
    computed: {
      imageSrc() {
        if (this.customImageUrl && this.customImageUrl.trim() !== '') {
          return this.customImageUrl;
        }
        return {
          nominale: '../../../images/project-img/PlaceH_nominale.png',
          sponsor: '../../../images/project-img/PlaceH_nominale.png',
          storica: '../../../images/project-img/PlaceH_Storica.png',
          'ruote-classiche': '../../../images/project-img/PlaceH_Classiche.png',
          'live-market': '../../../images/project-img/PlaceH_livemarket.png',
        }[this.type];
      },
      title() {
        return {
          nominale: 'Quotazione Nominale',
          sponsor: 'Quotazione Nominale',
          storica: 'Quotazione Storica',
          'ruote-classiche': 'Quotazione Ruote Classiche',
          'live-market': 'Report Live Market',
        }[this.type];
      },
      imageAlt() {
        return {
          nominale: 'Esempio Certificato Quotazione Nominale Dueruote',
          sponsor: 'Esempio Certificato Quotazione Sponsorizzata Dueruote',
          storica: 'Esempio Certificato Quotazione Storica Dueruote',
          'ruote-classiche': 'Esempio Certificato Quotazione Ruote Classiche Dueruote',
          'live-market': 'Esempio Report Live Market Dueruote',
        }[this.type];
      },
      downloadLink() {
        if (this.customLink && this.customLink.trim() !== '') {
          return this.customLink;
        }
        const baseLink = 'api/download-example-quotation';
        const queryParams = `vehicle_type=${encodeURIComponent(this.vehicle_type)}`;
        const links = {
          nominale: `${baseLink}?quotation_type=nominale&${queryParams}`,
          sponsor: `${baseLink}?quotation_type=nominale&${queryParams}`,
          storica: `${baseLink}?quotation_type=storica&${queryParams}`,
          'ruote-classiche': `${baseLink}?quotation_type=ruote-classiche&${queryParams}`,
          'live-market': `${baseLink}?quotation_type=live-market&${queryParams}`,
        };
        return links[this.type];
      },
      description() {
        if (this.customDescription && this.customDescription.trim() !== '') {
          return this.customDescription;
        }
        return {
          nominale: `La <span class="text-bold">Quotazione  Dueruote</span> fornisce un certificato di valutazione con una
          <span class="text-bold">stima affidabile del valore del veicolo, utile per vendere, acquistare o assicurare </span> la tua moto o il tuo scooter.
          Nel certificato troverai tre quotazioni:
          <ol>
            <li>il Valore di Vendita che stima il valore massimo del veicolo sul mercato dell'usato, considerando le sue condizioni e caratteristiche specifiche;</li>
            <li>il Valore di Acquisto che ti fornisce una valutazione realistica basata su modello, anno, chilometraggio, ecc., per evitare di pagare troppo per una moto usata o uno scooter usato;</li>
            <li>il Valore Assicurativo che ti offre un riferimento oggettivo per il rinnovo della copertura assicurativa contro furto e incendio, utilizzato dalle compagnie per calcolare il premio.</li>
          </ol>
          I valori riportati nel certificato sono il frutto di un'elaborazione delle informazioni acquisite sui principali portali di annunci compra/vendita di moto o scooter
          usati presenti sul territorio nazionale e rappresentano una panoramica del posizionamento del veicolo, aggiornata in tempo reale. La Quotazione Dueruote ti facilita
          le trattative per <span class="text-bold">vendere al giusto prezzo, acquistare con consapevolezza e assicurare adeguatamente il tuo veicolo.</span>`,
          sponsor: `La <span class="text-bold">Quotazione Nominale Dueruote</span> fornisce un certificato di valutazione...`,
          storica: `La <span class="text-bold">Quotazione Storica</span> fornisce un certificato di valutazione completo che <span class="text-bold">riporta le quotazioni storiche di Dueruote</span>,
           fonte autorevole nel settore delle due ruote. Nel certificato troverai diversi valori di riferimento utilizzati nel mercato delle moto e degli scooter usati che rappresentano una
           <span class="text-bold">stima affidabile del valore del veicolo, utile per vendere, acquistare o assicurare:</span>
           <ol>
            <li>il Valore di Mercato che stima il prezzo di vendita realistico basato su anno, chilometraggio e condizioni generali del veicolo;</li>
            <li>il Valore Assicurativo che consiste nel parametro oggettivo per le compagnie di assicurazione nel determinare i premi per le polizze furto/incendio. Il valore è riferito all’anno o semestre di prima immatricolazione, senza l’applicazione della variazione chilometrica e del mese di prima immatricolazione o l’aggiunta di optional a pagamento, è quella più comunemente applicata.</li>
            <li>il Valore Commerciale, usato da concessionari e rivenditori per valutazioni nelle permute e acquisti di moto e scooter usati;</li>
            <li>il Valore minimo garantito che rappresenta il valore sotto il quale difficilmente una moto o uno scooter vengono scambiati, indipendentemente dalle condizioni. Il valore tiene conto dei costi di gestione, dei rischi commerciali e degli oneri finanziari che il professionista dovrà sostenere per gestire il veicolo.</li>
          </ol>`,
          'ruote-classiche': `La Quotazione Ruote Classiche contiene la perizia dettagliata che valuta accuratamente il valore di un veicolo d’epoca o di interesse storico/collezionistico. Il certificato ufficiale esamina 7 fattori specifici che influenzano lo stato di conservazione e il valore della moto classica, quali:
          <ol>
            <li>Veicolo in perfetto stato o completamente restaurato</li>
            <li>Veicolo parzialmente restaurato</li>
            <li>In buono stato</li>
            <li>Condizioni di buona originalità ma con necessari interventi</li>
            <li>Incompleto in alcuni dettagli</li>
            <li>Incompleto di carrozzeria e/o meccanica</li>
            <li>Stato di relitto</li>
                </ol> La Quotazione fornisce una perizia dettagliata e obiettiva sulle condizioni del veicolo classico, permettendo una valutazione economica trasparente e affidabile per acquirenti, venditori e assicuratori.`,
          'live-market': `Il <span class="text-bold">Report Live Market</span> fornisce una panoramica aggiornata del mercato delle moto usate.
          Oltre alla Quotazione Nominale Dueruote, nel report troverai:
          <ol>
            <li>il <span class="text-bold">prezzo di mercato</span> calcolato sugli annunci reali;</li>
            <li>la <span class="text-bold">geolocalizzazione</span> dei veicoli in vendita intorno al tuo CAP;</li>
            <li>il <span class="text-bold">posizionamento</span> della tua moto rispetto a km, immatricolazione e prezzo degli annunci comparabili.</li>
          </ol>
          Un documento unico per capire dove si colloca il tuo veicolo sul mercato e negoziare con maggiore consapevolezza.`,
        }[this.type];
      },
    },
  };
  </script>



// WEBPACK FOOTER //
// resources/js/app/components/CertificateExample.vue